export const content = 0;
export const contentOverlay = 1;
export const loader = 2;
export const header = 5;
export const overlay = 10;
